import type { OfflineRefusal } from './capability'

/**
 * Turn a capability refusal into something an operator can act on.
 *
 * "Offline" alone is useless mid-service — each refusal has a different fix,
 * and the person holding the device is the one who has to apply it. Shared by
 * the counter (F-FE-N30) and the floor screen (F-FE-N125) so the same
 * condition is never explained two different ways.
 */
export function offlineHintForRefusal(reason?: OfflineRefusal): string {
  switch (reason) {
    case 'needs_native_shell':
      return 'Offline orders need the Bhookly desktop app or the Bhookly Android app — a browser tab cannot print kitchen tickets silently.'
    case 'no_station_cache':
      return 'Kitchen routing has not been cached yet — reconnect once so tickets know where to print.'
    default:
      return "Offline — your order is saved on this device. It'll place when you're back online."
  }
}
